import i18next from 'i18next';

i18next.addResources('en', 'Home', {
  login: 'Log In'
});
